/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Contacts.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type BloodGroup = 'NA' | 'A_Positive' | 'A_Negative' | 'B_Positive' | 'B_Negative' | 'AB_Positive' | 'AB_Negative' | 'O_Positive' | 'O_Negative';

export const BloodGroup = {
    NA: 'NA' as BloodGroup,
    A_Positive: 'A_Positive' as BloodGroup,
    A_Negative: 'A_Negative' as BloodGroup,
    B_Positive: 'B_Positive' as BloodGroup,
    B_Negative: 'B_Negative' as BloodGroup,
    AB_Positive: 'AB_Positive' as BloodGroup,
    AB_Negative: 'AB_Negative' as BloodGroup,
    O_Positive: 'O_Positive' as BloodGroup,
    O_Negative: 'O_Negative' as BloodGroup
};
